// extracted by mini-css-extract-plugin
module.exports = {"form-buttons":"FormFooter_form-buttons__18TXx","form-button-icons":"FormFooter_form-button-icons__1pm-N","btn-with-margin":"FormFooter_btn-with-margin__1_gQM"};